export const PLACE_NEW_ORDER = "PLACE_NEW_ORDER";
export const CANCEL_ORDER = "CANCEL_ORDER";  
export const SET_ORDERS = "SET_ORDERS";
export const UPDATE_ORDERS = "UPDATE_ORDERS";